export const RUTASCACHE = 'rutascache';
export const USRCACHE = 'usuarioscache';
export const PUNTOSCACHE = 'puntoscache';
export const RUTASIDS = 'rutasids';
export const UNITSCACHE = 'unidadescache';
